

import { Component, Vue } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import { JobAlertUI } from '../../models/JobAlert/JobAlertUI';
import { vxm } from './../../store.vuex';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { CommonJobAlert } from '../../models/JobAlert/commonjobalert';
import { AlertConfigDetails } from '../../models/JobAlert/alertconfigdetails';
import { Filter } from '../../../src/models/jobs/filter';
import { Geolocation } from '../../models/jobs/geolocation';
import { Latlong } from '../../models/jobs/latlong';
import { Locale } from '../../models/jobs/locale';
import Loader from './../Loader.vue';
import ConfirmationModal from '../Commons/ConfirmationModal.vue';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobAlertPage',
  components: {
    VueGoogleAutocomplete,
    Loader,
  },
})
export default class JobAlertPage extends Vue {
  $wlToastr: any;
  public keywords: string = '';
  public createAlert: boolean = false;
  public remoteJobType: string[] = [];
  private selectedJobAlert: JobAlertUI = new JobAlertUI();
  private deleteSelected: boolean = false;
  private selectedJobAlertToDelete: JobAlertUI = new JobAlertUI();
  private addressSearchText: string = '';
  private errorString: string = '';
  private successString: string = '';
  private commonJobAlert: CommonJobAlert = new CommonJobAlert();
  private latitude: number = 0.0;
  private longitude: number = 0.0;
  private locale: Locale = new Locale();
  private jobAlerts: JobAlertUI[] = [];
  private addressSearchTextEdit: string = '';
  private latitudeEdit: number = 0.0;
  private longitudeEdit: number = 0.0;
  private localeEdit: Locale = new Locale();
  private locationText: string = '';
  private googleAddressValue: boolean = false;
  private componentKey: number = 0;
  private frequencyPicked: string = '';
  private fields = { text: 'text', value: 'value' };
  $refs!: {
    address_filter: HTMLFormElement;
    address_filter2: HTMLFormElement;
  };
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }
  mounted() {
    this.jobAlerts = vxm.jobs.UserJobAlerts;
    // if(vxm.jobs.UserJobAlerts.length == 0){
    const respPromise: any = vxm.jobs.getJobAlerts(
      vxm.users.myUserProfile.email,
    );

    const frequencyRespPromise: any = vxm.jobs.getJobAlertsFrequency();
    if (vxm.jobs.FilterMetaData && !vxm.jobs.FilterMetaData.length) {
      vxm.jobs.fetchFiltersData();
    }
    Promise.all([respPromise, frequencyRespPromise]).then(
      (response) => {
        if (response) {
          this.jobAlerts = response[0].jobAlerts;
          vxm.jobs.setJobAlerts(this.jobAlerts);
          if (response[1].meta.success) {
            this.frequencyPicked = response[1].data.frequency;
          }
        }
      },
      (err) => {
        //this.$wlToastr("error", "Cannot load Job Alerts", "Job Alert");
      },
    );
    // }
  }

  get appTheme() {
    return vxm.utility.AppTheme;
  }

  refreshAfterEdit() {
    this.jobAlerts = vxm.jobs.UserJobAlerts;
    // if(vxm.jobs.UserJobAlerts.length == 0){
    const respPromise: any = vxm.jobs.getJobAlerts(
      vxm.users.myUserProfile.email,
    );

    const frequencyRespPromise: any = vxm.jobs.getJobAlertsFrequency();

    Promise.all([respPromise, frequencyRespPromise]).then(
      (response) => {
        if (response) {
          this.jobAlerts = response[0].jobAlerts;
          vxm.jobs.setJobAlerts(this.jobAlerts);
          if (response[1].meta.success) {
            this.frequencyPicked = response[1].data.frequency;
          }
        }
      },
      (err) => {
        //this.$wlToastr("error", "Cannot load Job Alerts", "Job Alert");
      },
    );
  }

  async manageFrequency() {
    const payload = {
      userId: vxm.users.myUserProfile.userId,
      frequency: this.frequencyPicked,
    };
    let respPromise = vxm.jobs.updateJobAlertFrequency(payload);
    const resp = await respPromise;
    if (resp.meta.success) {
      this.$wlToastr('success', this.$t('jobalert-frequency-updated-message'));
    } else {
      this.$wlToastr('error', this.$t('jobalert-frequency-updated-failed'));
    }
  }

  onAddressTextChange(text: string) {
    this.addressSearchText = text;
  }

  getAddressData(addressData, placeResultData, id) {
    this.latitude = addressData.latitude;
    this.longitude = addressData.longitude;
    this.locale.city = addressData.locality;
    this.locale.state = addressData.administrative_area_level_1;
    this.locale.country = addressData.country;
    this.locationText = addressData;
    this.googleAddressValue = true;
  }

  onNoResults() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }
  ////////////////Create Mthods ///////////////////////////////
  createJobAlert() {
    
    /* if (!this.keywords) {
      this.keywords = null;
    }*/
    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    if (!this.addressSearchText) {
      latlong.latitude = vxm.jobs.latitude;
      latlong.longitude = vxm.jobs.longitude;
    }
    latlong.latitude = this.latitude;
    latlong.longitude = this.longitude;

    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';
    geoLocation.locale = this.locale;
    geoLocation.latLong = latlong;
    if (!this.locale.city && this.locale.state) {
      geoLocation.locationType = 'administrative_area_level_1';
      geoLocation.locShortName = this.locale.state;
    } else {
      geoLocation.locationType = '';
      geoLocation.locShortName = '';
    }
    let alertConfigDetails = new AlertConfigDetails();
    alertConfigDetails.textCriteria = this.keywords;
    alertConfigDetails.address = this.addressSearchText;

    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    let jobAlertFilter = new Filter();
    jobAlertFilter.remoteJobType = this.remoteJobType;

    let jobAlert = new JobAlertUI();
    if (!this.keywords) {
      jobAlert.name = String(this.$t('jobalert.all.jobs'));
    } else {
      jobAlert.name = this.keywords;
    }

    jobAlert.email = vxm.users.myUserProfile.email;
    jobAlert.fullName =
      vxm.users.myUserProfile.firstName +
      ' ' +
      vxm.users.myUserProfile.lastName;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;
    jobAlert.filter = jobAlertFilter;
    jobAlert.status = 0;
    jobAlert.isActive = true;
    jobAlert.isValidated = false;
    this.commonJobAlert.jobAlert = jobAlert;
    this.saveJobAlert();
  }

  validJobAlert(): boolean {
    let isValid = false;
    if (this.keywords || this.addressSearchText) {
      isValid = true;
    } else {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryTitleOrLocationMsg'));
      isValid = false;
    }
    return isValid;
  }
  clearFieldValues() {
    this.keywords = '';
    this.remoteJobType = [];
    if (this.$refs.address_filter) {
      this.$refs.address_filter.update('');
      this.$refs.address_filter.clear();
    }
    if (this.$refs.address_filter2) {
      this.$refs.address_filter2.update('');
      this.$refs.address_filter2.clear();
    }
    this.addressSearchText = '';
  }
  saveJobAlert() {
    if (this.validJobAlert()) {
      vxm.jobs.createCommonJobAlert(this.commonJobAlert).then((res) => {
        if (res.success === true) {
          this.commonJobAlert.jobAlert.id = res.jobAlertId;
          this.jobAlerts.unshift(this.commonJobAlert.jobAlert);
          vxm.jobs.setJobAlerts(this.jobAlerts);
          vxm.users.Rudderstack.trackEvent("Job Alert Created", {
            jobAlertId: res.jobAlertId,
            jobAlertFrequency : vxm.jobs.getJobAlertsFrequency()
          })
          this.$wlToastr(
            'success',
            this.$t(this.successString),
            this.getJobAlertSuccessMessage(),
          );
          this.clearFieldValues();
          this.commonJobAlert = new CommonJobAlert();
        } else {
          this.$wlToastr(
            'error',
            res.errorMessage,
            this.$t('JobAlert_JobAlert').toString(),
          );
        }
      });
    }
    this.componentKey += 1;
    this.googleAddressValue = false;
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message').toString();
    }
    return this.$t('jobalert-created-anon-success-message').toString();
  }

  //////////////////////////////////////////////////

  deleteJobAlert(val: JobAlertUI) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('jobalert-confirm-delete-message'),
        body: this.$t('jobalert-delete-modal-message'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: this.deleteSelectedJobAlert,
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
    //const vm = this;
    // this.deleteSelected = true;
    this.selectedJobAlertToDelete = val;
  }

  deleteSelectedJobAlert() {
    const vm = this;
    const selectedJobAlertIdBeforeDelete = this.selectedJobAlertToDelete.id;
    vxm.jobs.deleteJobAlert(this.selectedJobAlertToDelete.id).then((res) => {
      if (res) {
        this.jobAlerts.forEach((item, index) => {
          if (item.id === this.selectedJobAlertToDelete.id)
            this.jobAlerts.splice(index, 1);
        });
        vxm.users.Rudderstack.trackEvent("Job Alert Deleted", {
          jobAlertId:selectedJobAlertIdBeforeDelete ,
          jobAlertFrequency : vxm.jobs.getJobAlertsFrequency()
        });
        vm.$wlToastr(
          'success',
          vm.$t('JobAlert_AlertDeletedSuccessfulyMsg').toString(),
          vm.$t('JobAlert_JobAlert').toString(),
        );
      } else {
        this.$wlToastr('error', res);
      }
    });
    this.componentKey += 1;
    this.deleteSelected = false;
  }
  cancelDeleteJobAlert() {
    this.deleteSelected = false;
    this.selectedJobAlertToDelete = new JobAlertUI();
  }

  ////////////////////// Delete End

  onAddressTextChangeEdit(text: string) {
    this.addressSearchTextEdit = text;
  }

  getAddressDataEdit(addressData, placeResultData, id) {
    this.latitudeEdit = addressData.latitude;
    this.longitudeEdit = addressData.longitude;
    this.localeEdit.city = addressData.locality;
    this.localeEdit.state = addressData.administrative_area_level_1;
    this.localeEdit.country = addressData.country;
  }

  onNoResultsEdit() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }

  editJobAlert(val: JobAlertUI) {
    this.selectedJobAlert.id = val.id;
    this.selectedJobAlert.name = val.name;
    this.selectedJobAlert.email = val.email;
    this.selectedJobAlert.fullName = val.fullName;
    this.selectedJobAlert.alertConfigDetails = val.alertConfigDetails;
    this.selectedJobAlert.filter.remoteJobType = val.filter.remoteJobType;
    this.selectedJobAlert.status = val.status;
    this.selectedJobAlert.isActive = val.isActive;
    this.selectedJobAlert.isValidated = val.isValidated;
    this.addressSearchTextEdit = val.alertConfigDetails.address;
    if (
      val.alertConfigDetails.geoLocation &&
      val.alertConfigDetails.geoLocation.latLong
    ) {
      this.latitudeEdit = val.alertConfigDetails.geoLocation.latLong.latitude;
      this.longitudeEdit = val.alertConfigDetails.geoLocation.latLong.longitude;
    }

    if (
      val.alertConfigDetails.geoLocation &&
      val.alertConfigDetails.geoLocation.locale
    ) {
      this.localeEdit.city = val.alertConfigDetails.geoLocation.locale.city;
      this.localeEdit.state = val.alertConfigDetails.geoLocation.locale.state;
      this.localeEdit.country =
        val.alertConfigDetails.geoLocation.locale.country;
    }
  }

  cancelEditJobAlert() {
    this.selectedJobAlert = new JobAlertUI();
  }

  validEditedJobAlert(): boolean {
    let isValid = false;
    if (this.selectedJobAlert.name || this.addressSearchTextEdit) {
      isValid = true;
    } else {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryTitleOrLocationMsg'));
      isValid = false;
    }
    return isValid;
  }
  get isMobileDevice() {
    return vxm.utility.isMobileDevice;
  }
  saveEditedJobAlert() {
    const vm = this;
    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    if (!this.addressSearchTextEdit) {
      latlong.latitude = vxm.jobs.latitude;
      latlong.longitude = vxm.jobs.longitude;
    }
    latlong.latitude = this.latitudeEdit;
    latlong.longitude = this.longitudeEdit;

    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';
    geoLocation.locale = this.localeEdit;
    geoLocation.latLong = latlong;
    if (!this.localeEdit.city && this.localeEdit.state) {
      geoLocation.locationType = 'administrative_area_level_1';
      geoLocation.locShortName = this.localeEdit.state;
    } else {
      geoLocation.locationType = '';
      geoLocation.locShortName = '';
    }

    let alertConfigDetails = new AlertConfigDetails();
    alertConfigDetails.textCriteria = this.selectedJobAlert.alertConfigDetails.textCriteria;
    alertConfigDetails.address = this.addressSearchTextEdit;
    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    let jobAlert = new JobAlertUI();
    jobAlert.id = this.selectedJobAlert.id;
    if (!this.selectedJobAlert.name) {
      jobAlert.name = String(this.$t('jobalert.all.jobs'));
      this.keywords = String(this.$t('jobalert.all.jobs'));
    } else {
      jobAlert.name = this.selectedJobAlert.name;
      this.keywords = this.selectedJobAlert.name;
    }
    jobAlert.email = vxm.users.myUserProfile.email;
    jobAlert.fullName =
      vxm.users.myUserProfile.firstName +
      ' ' +
      vxm.users.myUserProfile.lastName;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;

    let jobAlertFilter = new Filter();
    jobAlertFilter.remoteJobType = this.selectedJobAlert.filter.remoteJobType;
    jobAlert.filter = jobAlertFilter;
    jobAlert.status = this.selectedJobAlert.status;
    jobAlert.isActive = this.selectedJobAlert.isActive;
    jobAlert.isValidated = this.selectedJobAlert.isValidated;
    this.commonJobAlert.jobAlert = jobAlert;
    this.updateJobAlert();
  }

  updateJobAlert() {
    this.clearFieldValues();
    if (this.validEditedJobAlert()) {
      vxm.jobs.updateCommonJobAlert(this.commonJobAlert).then((res) => {
        if (res.success === true) {
          this.jobAlerts.forEach((item, index) => {
            if (item.id === this.selectedJobAlert.id)
              this.jobAlerts.splice(index, 1);
          });
          this.jobAlerts.unshift(this.commonJobAlert.jobAlert);
          this.refreshAfterEdit();
          //this.jobAlerts.push(this.commonJobAlert.jobAlert);
          vxm.users.Rudderstack.trackEvent("Job Alert Updated", {
            jobAlertId: res.jobAlertId,
            jobAlertFrequency : vxm.jobs.getJobAlertsFrequency()
          });
   this.$wlToastr(
            'success',
            this.$t(this.successString),
            this.$t('JobAlert_AlertSavedSuccessfulyMsg'),
          );
          this.selectedJobAlert = new JobAlertUI();
          this.commonJobAlert = new CommonJobAlert();
        } else {
          this.$wlToastr(
            'error',
            res.errorMessage,
            this.$t('JobAlert_JobAlert').toString(),
          );
        }
      });
    }
    this.componentKey += 1;
  }

  get remoteJobTypes() {
    const mapping = {
      yes: this.$t('jobalert.label.yes'),
      no: this.$t('jobalert.label.no'),
      partial: this.$t('jobalert.label.partial'),
    };
    if (vxm.jobs.FilterMetaData && vxm.jobs.FilterMetaData.length) {
      console.log(vxm.jobs.FilterMetaData);
      const remoteJobTypeFilter: any = vxm.jobs.FilterMetaData.find(
        (filter: any) => filter.name === 'JobPosting.remoteJobType',
      );
      if (remoteJobTypeFilter) {
        return remoteJobTypeFilter.filterValues.map((option) => ({
          value: option.value,
          text: mapping[option.value] || option.label,
        }));
      }
    }
    return [
      { value: 'yes', text: this.$t('jobalert.label.yes') },
      { value: 'no', text: this.$t('jobalert.label.no') },
      { value: 'partial', text: this.$t('jobalert.label.partial') },
    ];
  }

  getRemoteJobType(jobalert) {
    const remoteJobTypeTexts = jobalert.filter.remoteJobType.map(
      (remoteType) => {
        const value = this.remoteJobTypes.find(
          (type) => type.value === remoteType.toLowerCase(),
        );
        return (value && value.text) || '';
      },
    );
    return remoteJobTypeTexts.length
      ? this.$t('jobalert.label.remoteJobsSelectedOptions', {
          options: remoteJobTypeTexts.join(', '),
        })
      : '';
  }
}
